"use strict";
const _ = require('lodash');
// eslint-disable-next-line prefer-regex-literals
const regex = new RegExp('[\'"]', 'g');
const isQuoted = searchString => (_.startsWith(searchString, '"') && _.endsWith(searchString, '"')) ||
    (_.startsWith(searchString, "'") && _.endsWith(searchString, "'"));
const unQuotedString = searchString => searchString.replace(regex, '');
module.exports = { isQuoted, unQuotedString };
